/**
 * BIES Volume Selector
 * Sistema de descuentos por volumen usando productos bundle
 *
 * Tramos (política 22-sep-2026): 1 ud · 2 uds -10 % · 3 o más -15 %, sin tope.
 * Con 2 o 3+ unidades se pone en el formulario la variante del pack que
 * corresponde (BIES_COMPOSE_UNITS). Si la composición necesita varias
 * líneas (p. ej. 7 = 4x + 3x), el formulario envía esas líneas exactas en
 * items[i][id] / items[i][quantity]: nunca se añaden unidades sueltas.
 */

(function() {
  'use strict';

  // Use shared bundle map (loaded from bies-bundle-map.js)
  const BUNDLE_VARIANTS = window.BIES_BUNDLE_VARIANTS || {};

  class BiesVolumeSelector {
    constructor(container) {
      this.container = container;
      this.options = container.querySelectorAll('.bies-volume-selector__option');
      this.productId = container.dataset.productId;
      this.variantId = container.dataset.variantId;
      this.bundleCode = container.dataset.bundleCode;
      this.selectedQuantity = 1;

      // Obtener bundle variants del mapeo
      this.bundleVariants = BUNDLE_VARIANTS[this.bundleCode] || {};

      // Referencia al input de variant del formulario principal (buy-buttons)
      // Usamos la clase específica 'product-variant-id' para evitar el input de installment
      this.variantInput = document.querySelector('input.product-variant-id');

      // Referencia al formulario principal
      this.productForm = document.querySelector('form[data-type="add-to-cart-form"]');

      // Referencia al input de cantidad
      this.quantityInput = document.querySelector('.quantity__input') ||
                           document.querySelector('input[name="quantity"]');

      console.log('[BIES Volume] Initialized for product:', this.productId);
      console.log('[BIES Volume] Variant input found:', !!this.variantInput);
      console.log('[BIES Volume] Product form found:', !!this.productForm);
      console.log('[BIES Volume] Bundle code:', this.bundleCode);
      console.log('[BIES Volume] Bundle variants:', this.bundleVariants);

      this.init();
    }

    init() {
      this.bindEvents();
    }

    bindEvents() {
      // Click en opciones
      this.options.forEach(option => {
        option.addEventListener('click', (e) => this.handleOptionClick(e, option));
      });

      // Interceptar envío del formulario
      const form = document.querySelector('form[action="/cart/add"]') ||
                   document.querySelector('.product-form');

      if (form) {
        form.addEventListener('submit', (e) => this.handleFormSubmit(e, form));
      }
    }

    // Units currently chosen in the "3 o más" box (3 to BIES_MAX_UNITS).
    getMoreUnits() {
      const el = this.container.querySelector('[data-bies-more-units]');
      const n = el ? parseInt(el.textContent, 10) : 3;
      return n >= 3 ? n : 3;
    }

    // Repaint the "3 o más" box for `units` at the policy price (15 %).
    renderMoreBox(units) {
      const box = this.container.querySelector('.bies-volume-selector__option--more');
      if (!box) return;
      const base = parseInt(this.container.dataset.basePrice, 10) || 0;
      const discount = (typeof window.BIES_POLICY_DISCOUNT === 'function') ? window.BIES_POLICY_DISCOUNT(units) : 15;
      const original = base * units;
      const policyPrice = Math.floor((original * (100 - discount) + 50) / 100);   // same rounding as the Liquid
      // Packs are priced (and rounded) one by one, so a composition like 3x × 2
      // can come out 1 cent above policyPrice. Show whichever is higher so the
      // box never promises less than the cart will charge.
      let composedPrice = 0;
      const compose = window.BIES_COMPOSE_UNITS;
      const catalog = window.BIES_CATALOG_TIER_DISCOUNTS || {};
      if (typeof compose === 'function' && this.bundleCode) {
        compose(this.bundleCode, units).forEach(p => {
          composedPrice += Math.floor((base * p.tier * (100 - (catalog[p.tier] || 0)) + 50) / 100) * p.quantity;
        });
      }
      const final = Math.max(policyPrice, composedPrice);
      // Same look as the Liquid `| money` of the other boxes: €14,50
      const fmt = (cents) => '€' + new Intl.NumberFormat('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
      const set = (sel, text) => { const el = box.querySelector(sel); if (el) el.textContent = text; };
      set('[data-bies-more-units]', String(units));
      set('[data-bies-more-original]', fmt(original));
      set('[data-bies-more-final]', fmt(final));
      set('[data-bies-more-unit]', fmt(Math.floor(final / units)) + '/ud');
      set('.bies-volume-selector__quantity', units + (units === 1 ? ' unidad' : ' unidades'));
      box.dataset.quantity = String(units);
      const minus = box.querySelector('[data-bies-step="-1"]');
      if (minus) minus.disabled = units <= 3;
      const plus = box.querySelector('[data-bies-step="1"]');
      if (plus) plus.disabled = units >= (window.BIES_MAX_UNITS || 5);
    }

    handleOptionClick(e, option) {
      // Stepper inside the "3 o más" box: change units, keep the box selected.
      const step = e.target.closest('[data-bies-step]');
      if (step) {
        e.preventDefault();
        const max = window.BIES_MAX_UNITS || 5;
        const next = Math.min(max, Math.max(3, this.getMoreUnits() + parseInt(step.dataset.biesStep, 10)));
        this.renderMoreBox(next);
      }
      const previousQuantity = this.selectedQuantity;
      // Quitar selección de todas las opciones
      this.options.forEach(opt => opt.classList.remove('is-selected'));

      // Seleccionar la opción clickeada
      option.classList.add('is-selected');

      // Marcar el radio button
      const radio = option.querySelector('input[type="radio"]');
      if (radio) {
        radio.checked = true;
      }

      // Actualizar cantidad seleccionada
      this.selectedQuantity = parseInt(option.dataset.quantity, 10);

      // El control de cantidad solo se ve con "3 o más" seleccionado.
      const stepper = this.container.querySelector('[data-bies-more-stepper]');
      if (stepper) stepper.hidden = !option.classList.contains('bies-volume-selector__option--more');

      console.log('[BIES Volume] Selected quantity:', this.selectedQuantity);

      // Actualizar el variant ID si hay bundle disponible
      this.updateVariantId();

      // Track analytics
      this.trackAnalytics('volume_option_selected', {
        quantity: this.selectedQuantity,
        tier: option.dataset.tier,
        using_bundle: this.selectedQuantity > 1 && !!this.bundleCode
      });

      // Selection is an offer interaction, never evidence of a cart purchase.
      if (previousQuantity !== this.selectedQuantity) document.dispatchEvent(new CustomEvent('bies:volume:selected', { detail: {
        offer_id: String(this.productId || ''),
        offer_version: String(option.closest('.bies-volume-selector')?.dataset.biesOfferVersion || 'volume-v1')
      } }));
    }

    updateVariantId() {
      if (!this.variantInput) {
        console.error('[BIES Volume] ERROR: variantInput not found!');
        return;
      }

      const units = this.selectedQuantity;
      const compose = window.BIES_COMPOSE_UNITS;
      const parts = (typeof compose === 'function' && this.bundleCode) ? compose(this.bundleCode, units) : [];

      // Cualquier composición anterior de varias líneas se retira primero.
      this.clearComposition();

      if (units === 1 || !parts.length) {
        // Producto original con la cantidad elegida (sin packs para este producto).
        this.variantInput.value = this.variantId;
        this.setQuantity(units);
        console.log('[BIES Volume] Using original variant:', this.variantId, 'quantity:', units);
      } else if (parts.length === 1) {
        // Un solo tipo de pack cubre las unidades: 2x, 3x, 4x, 5x, o 3x × 2 = 6…
        this.variantInput.value = parts[0].variantId;
        this.setQuantity(parts[0].quantity);
        console.log('[BIES Volume] Using pack variant:', parts[0].variantId, 'quantity:', parts[0].quantity);
      } else {
        // Varias líneas (p. ej. 7 = 4x + 3x). Antes se añadían N unidades
        // SUELTAS para que el carrito las recompusiera, y si la unidad suelta
        // estaba agotada con stock 0 y sin venta en negativo (granolas, 1-oct)
        // Shopify rechazaba el añadido entero. Ahora el formulario lleva las
        // líneas exactas de packs en items[i][id] / items[i][quantity], que
        // /cart/add.js acepta en una sola llamada (probado en la tienda el
        // 7-oct), así que nunca se piden unidades sueltas.
        this.applyComposition(parts);
        console.log('[BIES Volume] Composition', units, 'units as', parts.map(p => p.quantity + '×' + p.tier + 'x').join(' + '));
      }
    }

    // El formulario de compra del producto (los inputs id/quantity viven en él
    // o apuntan a él con form="…").
    getForm() {
      if (this.variantInput && this.variantInput.form) return this.variantInput.form;
      return this.productForm;
    }

    // Pone en el formulario las líneas exactas de la composición y quita del
    // envío los campos id y quantity (sin borrarlos: solo pierden el name, que
    // es lo que FormData lee). Funciona igual con el interceptor del carrito
    // lateral y con el atajo temprano de theme.liquid, porque los dos envían
    // new FormData(form).
    applyComposition(parts) {
      const form = this.getForm();
      if (!form) return;
      [this.variantInput, this.quantityInput].forEach(el => {
        if (el && el.hasAttribute('name')) {
          el.dataset.biesName = el.getAttribute('name');
          el.removeAttribute('name');
        }
      });
      parts.forEach((p, i) => {
        [['id', p.variantId], ['quantity', p.quantity]].forEach(([key, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'items[' + i + '][' + key + ']';
          input.value = String(value);
          input.setAttribute('data-bies-composition', '');
          form.appendChild(input);
        });
      });
      // El id visible sigue apuntando a una variante real (la del pack mayor)
      // para quien lo lea fuera del envío.
      this.variantInput.value = parts[0].variantId;
    }

    clearComposition() {
      const form = this.getForm();
      if (form) form.querySelectorAll('[data-bies-composition]').forEach(el => el.remove());
      [this.variantInput, this.quantityInput].forEach(el => {
        if (el && el.dataset.biesName) {
          el.setAttribute('name', el.dataset.biesName);
          delete el.dataset.biesName;
        }
      });
    }

    setQuantity(qty) {
      if (this.quantityInput) {
        this.quantityInput.value = qty;
        // Disparar eventos para que el tema lo detecte
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    handleFormSubmit(e, form) {
      // Asegurar que el variant ID y cantidad están correctos antes del submit
      console.log('[BIES Volume] Form submitting with variant:', this.variantInput?.value, 'quantity:', this.quantityInput?.value);

      // El variant ID y la cantidad ya están configurados en updateVariantId()
      // Solo logueamos para debugging
      if (this.selectedQuantity > 1) {
        console.log('[BIES Volume] Submitting', this.selectedQuantity, 'units of', this.bundleCode);
      }
    }

    trackAnalytics(eventName, data) {
      // Google Analytics / GA4
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'bies_volume_' + eventName,
          ...data
        });
      }

      // Klaviyo
      if (window._learnq) {
        window._learnq.push(['track', 'Volume Discount ' + eventName, data]);
      }
    }
  }

  // Inicializar cuando el DOM esté listo
  function init() {
    const containers = document.querySelectorAll('.bies-volume-selector');
    containers.forEach(container => {
      if (!container.dataset.initialized) {
        new BiesVolumeSelector(container);
        container.dataset.initialized = 'true';
      }
    });
  }

  // Inicializar
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-inicializar si hay cambios dinámicos
  document.addEventListener('shopify:section:load', init);

})();
